import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "18", height: "7", x: "3", y: "3", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "9", height: "7", x: "3", y: "14", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "5", height: "7", x: "16", y: "14", rx: "1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LayoutTemplate";
const LayoutTemplate = memo(themed(Icon));
export {
  LayoutTemplate
};
//# sourceMappingURL=layout-template.js.map
